<form [formGroup]="restrictionForm" class="rkt-form">
  <rkt-form [form]="restrictionForm" [fields]="restrictionFormFields" [model]="formModel" />
</form>
